import React, { useCallback, useEffect, useRef, useState } from "react";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import { Colors } from "../../../assets/colors/Colors";
import Tooltip from "@mui/material/Tooltip";

import Slider from '@mui/material/Slider';
import RadioButtonForm from "../../../components/ComponentesFormularios/RadioButtonForm";
import { CalendarForm, CalendarFormRange } from "../../../components/ComponentesFormularios/CalendarForm";
import { modalCRUDService } from "../../../services/modalCRUDService";
import { GlobalConstants } from "../../../data/GlobalConstants";
import { useDispatch, useSelector } from "react-redux";
import ImagePicker from "src/components/ComponentesFormularios/ImagePicker";
import TransfertList from "../../../components/TransferList";

import {
    convertToString,
    dateToStringFormat, getDateTime,
    getFechaToCalendarRange,
    validarEspaciosEnBlanco,
    validArray
} from "../../../util/functions";
import { FormProvider, useForm, useFormContext, useWatch } from "react-hook-form";
import { isEmpty, isObject } from "../../../util/is";
import SelectFormVirtualize from "../../../components/ComponentesFormularios/SelectFormVirtualize";
import {
    classResponsiveForm,
    classResponsiveFormDoubleWidth, classResponsiveFormWidthHeader, ERRORFIELDREQUIRED,
    optionsEstados,
    optionsYesNo
} from "../../../data/ConstantForm";
import { referenciasService } from 'src/services/apiReferencias'
import TabsClassic from "src/components/TabsClassic";
import AgGridTable from "src/components/AgGridTable";
import AccionesTable from "src/components/AccionesTable";

import Emitter from "src/EventEmitter/EventEmitter";
import { ConstantEventEmitter } from "src/data/ConstantEventEmitter";
import { alertQuestionService } from "src/services/alertQuestionService";

import { crearActivosService } from "src/services/apiCrearActivos";

const columnDef = [
    {headerName: 'Descripción', field: "nmAccesorio", resizable: true, sortable: false, filter: false },
    {headerName: 'Cantidad', field: "nbCantidad", resizable: true, sortable: true, editable: true},
    {headerName: 'Acciones',field: "acciones", cellRenderer: 'accionesComponent', width: '100%'},
]

function valuetext(value) {
    return `${value}°C`;
}

const minDistance = 10;

const formatCurrency = amount => {
    return (Math.round(amount * 100) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

const AccionesAccesorios = ({ params }) => {

    return (
        <AccionesTable accionesBasicas={false} editAction={false} deleteAccion={true} params={params} />
    )
}

const Accesorios = ({isEditing, tableRefAcc}) => {

    const { handleSubmit, setValue, control, formState: { errors } } = useFormContext();
    const dispatch = useDispatch();

    const nombre = useWatch({
        name: "nombre",
        control
    })

    const cantidad = useWatch({
        name: "cantidad",
        control
    })

    const addToTable = () => {


        if (nombre == '' || nombre == undefined) {

            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Agregue una descripción y una cantidad' } });
            return
        }

        let cont = 1,
            result = []

        tableRefAcc.current.api.forEachNodeAfterFilter( node => {
            node.data['id'] = cont
            result.push(node.data)
            cont ++
        })

        result.push({
            id: cont,
            nmAccesorio: nombre,
            nbCantidad: cantidad
        });

        tableRefAcc.current.api.setRowData(result)

        setValue('nombre','')
        setValue('cantidad',0)
    }

    useEffect(() => {
      if(cantidad <= 0){
          setValue('cantidad', '')
      }
    }, [cantidad])


    return (
        <>
            <div className="d-flex align-items-center">
                <InputForm inputProps={{ control }} identificador="nombre" label="Descripción" readOnly={!isEditing}
                        placeholder="" required={false} type="text" className={`${classResponsiveFormWidthHeader}`}
                        customError={errors.nombre ? ERRORFIELDREQUIRED : null} />

                <InputForm inputProps={{ control }} identificador="cantidad" label="Cantidad" readOnly={!isEditing}
                        placeholder="" required={false} type="number" className={`${classResponsiveFormWidthHeader}`}
                        customError={errors.cantidad ? ERRORFIELDREQUIRED : null}/>

                <Tooltip title="Agregar" aria-label="Agregar">
                    <a onClick={() => addToTable() } className="icon-container-actions d-flex">
                      <div style={{backgroundColor: Colors.COLOR_BLUE_THEME}}/>
                      <i style={{color: Colors.COLOR_BLUE_THEME}} className="fas fa-plus fa-2x"/>
                    </a>
                </Tooltip>
            </div>

            <AgGridTable
                referencia={tableRefAcc}
                columnDef={columnDef}
                dataList={[]}
                height='30vh'
                acciones={AccionesAccesorios}
                rowSelection="multiple"/>
            </>
    )
}

const RangePresupuesto = ({ isEditing,stateSelects,rangeSelected }) => {

    const { handleSubmit, setValue, control, formState: { errors } } = useFormContext();
    const [ state, setState] = useState({unavailable: false, required: true})
    const [valueRange, setValueRange] = useState(rangeSelected || [50, 80])
    const min = useRef(null);
    const medio = useRef(null);
    const max = useRef(null);
    let minimo = 0,
        maximo = 0,
        intermedio1 = 0,
        intermedio2 = 0

    const aplicaPresupuesto = useWatch({
        name: "aplicaPresupuesto",
        control
    })

    const vlrPresupuesto = useWatch({
        name: "vlrPresupuesto",
        control
    })


    const handleChange = (event, newValue, activeThumb) => {

        if (!Array.isArray(newValue)) {
            return;
        }

        if (newValue[1] - newValue[0] < minDistance) {
            if (activeThumb === 0) {
                const clamped = Math.min(newValue[0], 100 - minDistance);
                setValueRange([clamped, clamped + minDistance]);
            } else {
                const clamped = Math.max(newValue[1], minDistance);
                setValueRange([clamped - minDistance, clamped]);
            }
        }
        else {
            setValueRange(newValue);
        }
    };

    useEffect(() => {
      if(vlrPresupuesto < 0) {
          setValue('vlrPresupuesto', 0)
      }
    }, [vlrPresupuesto])

    useEffect(() => {
        setValue('aplicaPresupuesto', 'N')
    }, [])
    


    useEffect(() => {

        min.current.innerText = '$0'
        medio.current.innerText = '$0'
        max.current.innerText = '$0'
        if (Number(vlrPresupuesto) > 0) {

            minimo = Number(vlrPresupuesto) * Number(valueRange[0]) / 100
            maximo = Number(vlrPresupuesto) * Number(valueRange[1]) / 100
            intermedio1 = minimo + 1
            intermedio2 = maximo - 1

            min.current.innerText = `$${formatCurrency(minimo)}`
            medio.current.innerText = `$${formatCurrency(intermedio1)} - $${formatCurrency(intermedio2)}`
            max.current.innerText = `$${formatCurrency(maximo)}`

            setValue('prcPresupuesto', valueRange)
        }

        if (aplicaPresupuesto === 'N') {
            setState({...state, unavailable: true, required: false})
        }
        else {
            setState({ ...state, unavailable: false, required: true })
        }


    }, [valueRange,vlrPresupuesto,aplicaPresupuesto])



    return (
        <>
            <div className="row mx-0 px-0 mt-3 mb-2">
                <RadioButtonForm inputProps={{ control }} disabled={!isEditing} identificador="aplicaPresupuesto" options={optionsYesNo} required={true}
                    defaultValue="N" label="Aplica Presupuesto" className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.aplicaInventario ? ERRORFIELDREQUIRED : null} />

                <SelectFormVirtualize inputProps={{ control }} showId={false} disabled={state.unavailable} identificador="frecuencia" label="Frecuencia"
                        options={stateSelects.arrFrecuencias} required={state.required} className={`${classResponsiveFormWidthHeader}`}
                        customError={errors.frecuencia ? ERRORFIELDREQUIRED : null} />

                <InputForm inputProps={{ control }} identificador="vlrPresupuesto" label="Valor Presupuesto" disabled={state.unavailable} readOnly={!isEditing}
                        placeholder="" required={state.required} type="number" className={`${classResponsiveFormWidthHeader}`}
                        customError={errors.vlrPresupuesto ? ERRORFIELDREQUIRED : null} rules={{  min: state.required ? 1 : 0}} />

                {/* <strong>Establecer Presupuesto y cumplimiento configurando los siguientes indicadores</strong> */}
            </div>
            <div className="row mx-0 px-0 mt-3 mb-2">

                <Slider
                    getAriaLabel={() => 'Minimum distance shift'}
                    value={valueRange}
                    onChange={handleChange}
                    valueLabelDisplay="auto"
                    getAriaValueText={valuetext}
                    disableSwap
                />

            </div>
            <div className="row mx-0 px-0 mt-3 mb-2">
                <div ref={min} className="" style={{backgroundColor: '#fff',textAlign: 'center',borderBottomColor: 'red', width: '24%', marginRight: '1%', fontSize: '20px'}}> &nbsp;</div>
                <div ref={medio} className="" style={{backgroundColor: '#fff',textAlign: 'center', width: '50%', marginRight: '1%', fontSize: '20px'}}> </div>
                <div ref={max} className="" style={{backgroundColor: '#fff',textAlign: 'center', width: '24%', fontSize: '20px'}}> </div>
            </div>
            <div className="row mx-0 px-0 mt-1 mb-2">
                <div className="rounded" style={{backgroundColor: 'red',textAlign: 'center',borderBottomColor: 'red', width: '24%', marginRight: '1%', height: '5px'}}> &nbsp;</div>
                <div className="rounded" style={{backgroundColor: 'yellow',textAlign: 'center', width: '50%', marginRight: '1%', height: '5px'}}> </div>
                <div className="rounded" style={{backgroundColor: 'green',textAlign: 'center', width: '24%', height: '5px'}}> </div>
            </div>
            <div className="row mx-0 px-0 mt-1 mb-2">
                <div className="rounded" style={{textAlign: 'center',borderBottomColor: 'red', width: '24%', marginRight: '1%'}}> Menor Igual</div>
                <div className="rounded" style={{textAlign: 'center', width: '50%', marginRight: '1%'}}>Rango</div>
                <div className="rounded" style={{textAlign: 'center', width: '24%'}}>Mayor Igual</div>
            </div>

        </>
    )
}

const PortafolioMateriales = React.memo(({isEditing, stateSelects, selectedProductos, isAddMode}) => {

    const { setValue, control, formState: { errors } } = useFormContext();

    const [ state, setState] = useState({unavailable: false, required: true})
    const [data, setData] = useState([])

    let arrProductosMateriales = []
    let arrPortafolios = []

    const subPortafolio = useWatch({
        name: "subPortafolios",
        control
    })

    const aplicaMateriales = useWatch({
        name: "aplicaMateriales",
        control
    })

    const onChange = ({dataSelectedTemp}) => {

        let error = false;
        try{

            dataSelectedTemp.map( item => arrProductosMateriales.push({nbProducto: item.id,nmProducto: item.text}))
            subPortafolio.map( item => arrPortafolios.push({nbPortafolio: item.id,nmPortafolio: item.text}))

        }
        catch (e) { error = true; }

        if(!error){
            setValue("jsProductos", arrProductosMateriales)
            setValue("jsPortafolios", arrPortafolios)
        }
    }

    useEffect(() => {
        setValue('aplicaMateriales', 'N')
    }, [])
    

    useEffect(() => {

        let subPortafoliosTemp = validArray(subPortafolio).slice()

        let productos = []
        subPortafoliosTemp?.map( (el,index) => {

            if(index == 0){
                productos = validArray(el?.jsProductos).slice()
            }
            else{
                el?.jsProductos?.map(prod =>{
                    if(productos.findIndex(pr => pr.id == prod.id) == -1){
                        productos.push(prod)
                    }
                })
            }
        })
        setState({...state, unavailable: false})

        setData(productos)

        if (arrPortafolios.length === 0 ) {
            let subs = [],
                products = []
            selectedProductos?.map( item => products.push({nbProducto: item.id,nmProducto: item.text}))
            subPortafolio?.map( item => subs.push({nbPortafolio: item.id,nmPortafolio: item.text}))

            setValue("jsProductos", products)
            setValue("jsPortafolios", subs)
        }

        if (aplicaMateriales === 'N') {
            setState({...state, unavailable: true, required: false})
            setData([])
        }
        else {
            setState({...state, unavailable: false, required: true})
        }

    }, [subPortafolio,aplicaMateriales])

    return (
        // <div className="mt-2">
        <div className=" mt-2">
            <div className="row mx-0 px-0 mt-3 mb-2">
                <RadioButtonForm inputProps={{ control }} disabled={!isEditing} identificador="aplicaMateriales" options={optionsYesNo} required={true}
                    defaultValue="N" label="Aplica Materiales" className={`${classResponsiveFormWidthHeader} ml-5`}
                    customError={errors.aplicaMateriales ? ERRORFIELDREQUIRED : null} />

                <SelectFormVirtualize inputProps={{ control }} isMulti={true} disabled={state.unavailable} identificador="subPortafolios" label="Portafolio de Materiales"
                    options={stateSelects?.arrSubPortafolios} required={state.required} className={`w-25 ml-5`} readOnly={false}
                    customError={errors.subPortafolios ? ERRORFIELDREQUIRED : null} />
            </div>

            <div className="row mx-0 px-0 mt-3 mb-2 d-flex">

                <div className="">
                    <TransfertList dataShow={data || []}
                        dataSelect={selectedProductos || []}
                        disabled={!isEditing}
                        onChange={({dataSelectedTemp}) => onChange({dataSelectedTemp})}
                        labelMuestra="Portafolio de Materiales" labelSelected="Materiales"/>
                </div>
            </div>

        </div>
    )
})

const DatosBasicos = React.memo(({ isEditing, isAddMode, properties, stateSelects, tableRefAcc }) => {

    const { data, params, tableRef } = properties;
    const { control, formState: { errors } } = useFormContext();
    const isMount = useRef(true);

    let jsReferencia =  data?.jsReferencia ? JSON.parse(data.jsReferencia) : {}

    const handleDeleteRowTable = ({params, type}) => {
        const rowData = params.node.data;
        params.api.applyTransaction({
            remove: [rowData]
        })

        alertQuestionService.clear();
    }

    useEffect(() => {
        return () => {
            isMount.current = false;

            Emitter.off(ConstantEventEmitter.eventDeleteTable);
        }
    }, [])

    useEffect(() => {

        tableRefAcc.current.api.setRowData(jsReferencia?.arrAccesorios)

        Emitter.on(ConstantEventEmitter.eventDeleteTable, ({ params, type }) => handleDeleteRowTable({ params, type }));
    }, [])

    return (
        <div className="container mx-0 px-0 w-100 mw-100">

            <div className="mt-3 p-2 bg-white" style={{border: '1px solid #C6C6C6', borderRadius: 5}}>

                <h4>Referencia</h4>

                <hr className="m-0 p-0"/>

                <div className="row mx-1 align-items-center justify-content-between mt-2">

                    <CalendarForm inputProps={{ control }} disabled={true} identificador="dtCreacion" label="Fecha Creación"
                        required={true} className={`${classResponsiveFormWidthHeader}`} customError={errors.dtCreacion ? ERRORFIELDREQUIRED : null} />

                    <RadioButtonForm inputProps={{ control }} disabled={!isEditing} identificador="estado" options={optionsEstados} required={true}
                        defaultValue="1" label="Estado" className={`${classResponsiveFormWidthHeader}`}
                        customError={errors.estado ? ERRORFIELDREQUIRED : null} />

                </div>

                <div className="row mx-1 align-items-center justify-content-start mt-2">

                    <SelectFormVirtualize inputProps={{ control }} showId={false} disabled={!isEditing} identificador="tipoReferencia" label="Tipo de Activo"
                        options={stateSelects?.arrTipoActivos} required={true} className={`${classResponsiveFormWidthHeader}`} readOnly={false}
                        customError={errors.tipoReferencia ? ERRORFIELDREQUIRED : null} />

                    <InputForm inputProps={{ control }} identificador="marca" label="Marca(Fabricante)" readOnly={!isEditing}
                        placeholder="" required={true} type="text" className={`${classResponsiveFormWidthHeader}`}
                        customError={errors.marca ? ERRORFIELDREQUIRED : null} />

                    <InputForm inputProps={{ control }} identificador="referencia" label="Referencia" readOnly={!isEditing}
                        placeholder="" required={true} type="text" className={`${classResponsiveFormWidthHeader}`}
                        customError={errors.referencia ? ERRORFIELDREQUIRED : null} />
                </div>

            </div>

            <div className='mt-3 d-flex align-items-center px-3 py-4 bg-white boxShadow borderRadius5'>
                    <TabsClassic
                        tabs={[
                            {
                                id: 1,
                                label: "Caracteristicas",
                                content: <div className="row mx-1 align-items-center justify-content-start mt-2">

                                            <InputForm inputProps={{ control }} identificador="alto" label="Alto" readOnly={!isEditing}
                                                placeholder="" required={true} type="text" className={`${classResponsiveFormWidthHeader}`}
                                                customError={errors.alto ? ERRORFIELDREQUIRED : null} />

                                            <InputForm inputProps={{ control }} identificador="ancho" label="Ancho" readOnly={!isEditing}
                                                placeholder="" required={true} type="text" className={`${classResponsiveFormWidthHeader}`}
                                                customError={errors.ancho ? ERRORFIELDREQUIRED : null} />

                                            <InputForm inputProps={{ control }} identificador="profundidad" label="Profundidad" readOnly={!isEditing}
                                                placeholder="" required={true} type="text" className={`${classResponsiveFormWidthHeader}`}
                                                customError={errors.profundidad ? ERRORFIELDREQUIRED : null} />

                                            <InputForm inputProps={{ control }} identificador="capacidad" label="Capacidad" readOnly={!isEditing}
                                                placeholder="" required={true} type="text" className={`${classResponsiveFormWidthHeader}`}
                                                customError={errors.capacidad ? ERRORFIELDREQUIRED : null} />

                                            <ImagePicker inputProps={{ control }} label="Avatar" required={false} disabled={!isEditing} identificador="imagen"
                                                            className="px-2 col-12" />

                                        </div>
                            },
                            {
                                id: 2,
                                label: "Accesorios",
                                content: <Accesorios isEditing={isEditing} tableRefAcc={tableRefAcc} />
                            },
                            {
                                id: 3,
                                label: "Presupuesto y Cumplimiento",
                                content: <RangePresupuesto isEditing={isEditing} stateSelects={stateSelects} rangeSelected={data.rangosPresupuesto} />
                            },
                            {
                                id: 4,
                                label: "Materiales",
                                content: <PortafolioMateriales isEditing={isEditing} selectedProductos={data.arrProductos} stateSelects={stateSelects} isAddMode={isAddMode} />
                            },
                        ]} />
                </div>

            {/* <div className="mt-3 p-2 bg-white" style={{border: '1px solid #C6C6C6', borderRadius: 5}}>

                <h4>Caracteristicas</h4>
                <hr className="m-0 p-0"/>

                <div className="row mx-1 align-items-center justify-content-start mt-2">

                    <InputForm inputProps={{ control }} identificador="alto" label="Alto" readOnly={!isEditing}
                        placeholder="" required={true} type="text" className={`${classResponsiveFormWidthHeader}`}
                        customError={errors.alto ? ERRORFIELDREQUIRED : null} />

                    <InputForm inputProps={{ control }} identificador="ancho" label="Ancho" readOnly={!isEditing}
                        placeholder="" required={true} type="text" className={`${classResponsiveFormWidthHeader}`}
                        customError={errors.ancho ? ERRORFIELDREQUIRED : null} />

                    <InputForm inputProps={{ control }} identificador="profundidad" label="Profundidad" readOnly={!isEditing}
                        placeholder="" required={true} type="text" className={`${classResponsiveFormWidthHeader}`}
                        customError={errors.profundidad ? ERRORFIELDREQUIRED : null} />

                    <ImagePicker inputProps={{ control }} label="Avatar" required={false} disabled={!isEditing} identificador="imagen"
                                    className="px-2 col-12" />

                </div>
            </div> */}

            {/* <div className="mt-3 p-2 bg-white" style={{border: '1px solid #C6C6C6', borderRadius: 5}}>
                <h4>Presupuesto y Cumplimiento</h4>
                <hr className="m-0 p-0"/>

                <RangePresupuesto isEditing={isEditing} stateSelects={stateSelects} rangeSelected={data.rangosPresupuesto} />
            </div> */}

            {/* <div className="mt-3 p-2 bg-white" style={{border: '1px solid #C6C6C6', borderRadius: 5}}>
                <h4>Materiales</h4>
                <hr className="m-0 p-0"/>

                <div className="d-flex justify-content-center">
                    <PortafolioMateriales isEditing={isEditing} selectedProductos={data.arrProductos} stateSelects={stateSelects} isAddMode={isAddMode} />
                </div>
            </div> */}

        </div>
    )
})

const FormReferenciaCRUD = ({ isEditing, properties, isAddMode }) => {

    const tableRefAcc = useRef(null);
    const { data, params, tableRef } = properties;
    const dispatch = useDispatch();
    const authState = useSelector(state => state.auth)
    const { idUsuario } = authState;
    const generalServicesState = useSelector(state => state.generalServices)
    const methods = useForm({
        defaultValues: {
            ...data
        }
    });
    const { register, handleSubmit, formState: { errors }, control } = methods;

    const propietario = useWatch({
        name: 'propietario',
        control
    })

    useEffect(() => {
      referenciasService.getTipoActivos(isObject(propietario) ? propietario['id'] : propietario ).then(
          response => {
            const { status, msg, data } = response;

            if(status) {
                dispatch({
                    type: 'setStateGeneralServices', generalServices: {
                        ...generalServicesState,
                        arrTipoActivos: data
                    }
                })
            }
          }
      )
    }, [propietario])


    const onSuccessSubmit = data => {

        data.idUsrAuditoria = idUsuario;
        data.ac = isAddMode && isEditing ? 'C' : isEditing ? 'A' : 'LOCK';

        data.imagen = data.imagen === undefined ? undefined : isEditing ? data.imagen ? data.imagen[0] : undefined : data.imagen[0]

        let jsAccesorios = []
        tableRefAcc.current.api.forEachNodeAfterFilter( nodo => {
            jsAccesorios.push({
                nmAccesorio: nodo.data.nmAccesorio,
                nbCantidad: nodo.data.nbCantidad
            })
        })

        data.arrAccesorios = jsAccesorios

        if (data.ac === 'A') {
            delete data.arrProductos
            delete data.jsReferencia
            delete data.subPortafolios
        }

        referenciasService.crudReferencias(data).then(
            response => {

                const { status, msg, data: datos } = response;

                if (status) {
                    if (datos?.idmsg === 200) {

                        if (isAddMode) {
                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: datos?.txmsg } });

                            tableRef.current.api.applyTransaction({
                                add: [{
                                    id: datos?.idreg,
                                    estado: data.estado,
                                    tpReferencia: isObject(data.tipoReferencia) ? data.tipoReferencia.text : data.tipoReferencia,
                                    marca: data.marca,
                                    referencia: data.referencia,
                                    ancho: data.ancho,
                                    alto: data.alto,
                                    profundidad: data.profundidad,
                                    aplicaPresupuesto: data.aplicaPresupuesto == 'S' ? 'SI' : 'NO',
                                    aplicaMateriales: data.aplicaMateriales == 'S' ? 'SI' : 'NO',
                                    usrAuditor: idUsuario,
                                }]
                            })
                        }
                         else {

                             dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: datos?.txmsg } });

                             const rowNode = params.api.getRowNode(params.node.id);

                             rowNode.setDataValue("estado", data?.estado)
                             rowNode.setDataValue("tpReferencia", isObject(data.tipoReferencia) ? data.tipoReferencia.text : data.tipoReferencia)
                             rowNode.setDataValue("marca", data.marca)
                             rowNode.setDataValue("referencia", data?.referencia)
                             rowNode.setDataValue("ancho", data?.ancho)
                             rowNode.setDataValue("alto", data?.alto)
                             rowNode.setDataValue("profundidad", data.profundidad)
                             rowNode.setDataValue("aplicaPresupuesto", data.aplicaPresupuesto == 'S' ? 'SI' : 'NO')
                             rowNode.setDataValue("aplicaMateriales", data.aplicaMateriales == 'S' ? 'SI' : 'NO')
                         }

                         modalCRUDService.clear();
                    }
                    else {
                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: datos?.txmsg } });
                    }

                } else {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: msg } });
                }

            },
            error => {
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } });
            }
        );
    }

    const onErrorSubmit = errors => {
        tableRefAcc.current.api.forEachNodeAfterFilter( nodo => {
            console.log(nodo.data)
        })
        console.log(errors)
    }

    return (
        <FormProvider {...methods} >
                <header className="px-4 d-flex align-items-center mw-100 mt-2 justify-content-between">

                    <div className="row w-50">

                        <InputForm inputProps={{ control }} identificador="idReferencia" label="Id Referencia" disabled={!isAddMode}
                            placeholder="" required={false} type="text" className={`${classResponsiveFormWidthHeader}`} style={{width: '12em', marginLeft: 0}}
                            customError={errors.idReferencia ? ERRORFIELDREQUIRED : null} />

                        <SelectFormVirtualize inputProps={{ control }} showId={false} disabled={!isEditing} identificador="propietario" label="Propietario"
                            options={generalServicesState?.arrPropietarios} required={true} className={`px-2 w-50`} readOnly={false}
                            customError={errors.propietario ? ERRORFIELDREQUIRED : null} />
                    </div>

                    <div className="d-flex justify-content-end align-items-center">
                        {isEditing &&
                            <Tooltip title="Guardar" aria-label="guardar">
                                <a onClick={handleSubmit(onSuccessSubmit, onErrorSubmit)}
                                    className="icon-container-actions d-flex">
                                    <div style={{ backgroundColor: Colors.COLOR_GREEN_DARK }} />
                                    <i style={{ color: Colors.COLOR_GREEN_DARK }} className="fas fa-check fa-2x" />
                                </a>
                            </Tooltip>
                        }
                        <Tooltip title="Cancelar" aria-label="cancelar">
                            <a onClick={() => { modalCRUDService.clear() }} className="icon-container-actions d-flex">
                                <div style={{ backgroundColor: Colors.RED_SWITCH_INACTIVE }} />
                                <i style={{ color: Colors.RED_SWITCH_INACTIVE }} className="fas fa-times fa-2x" />
                            </a>
                        </Tooltip>
                    </div>

                </header>
                <DatosBasicos isEditing={isEditing} properties={properties} stateSelects={generalServicesState} isAddMode={isAddMode} tableRefAcc={tableRefAcc} />
        </FormProvider>
    )

}

export default FormReferenciaCRUD;
